<template>
  <b-modal
    v-model="modal"
    class="position-relative"
    lazy
    centered
    body-class="py-5"
    content-class="new-section-modal"
    size="md"
    hide-footer
    hide-header
  >
    <i
      class="fa fa-close z-[50] absolute top-[15px] right-[17px] text-[16px] text-[#6E747A] transition cursor-pinter hover:opacity-60"
      @click="modal = false"
    />
    
    <h3 class="text-center font-weight-bold mb-12 px-0">
      Import Variable
    </h3>

    <b-form
      class="px-4"
      @submit.prevent="submit"
    >
      <b-row>
        <b-col>
          <b-form-group
            label="Add Share Code"
            label-class="pm-label"
          >
            <b-input
              v-model="hash"
              :disabled="loading"
              required
              class="pm-input"
            />
          </b-form-group>

          <div class="text-center mt-5">
            <b-btn
              type="submit"
              variant="primary"
              class="font-weight-bold font-size-14 px-5"
              :disabled="loading"
            >
              Add New Variable
              <b-spinner
                v-if="loading"
                class="mr-2"
                variant="light"
                small
              />
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'GlobalVariableImport',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      hash: ''
    }
  },
  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    ...mapState('modal', {
      modals: state => state.modals
    }),
    modal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    async submit () {
      this.$emit('submit', this.hash)
      // VEvent.fire('loader', true)
      // await axios.post(`/api/projects/${this.project.id}/import-variables`, {
      //   hash: this.hash.split(',')
      // })
      //   .then(async () => {
      //     await this.$store.dispatch('projects/load')
      //     this.$swal({
      //       icon: 'success',
      //       title: 'Done!',
      //       text: 'The global variables have been imported.',
      //       showConfirmButton: false,
      //       timer: 1500
      //     })
      //   })
      //   .catch((err) => {
      //     console.error(err)
      //     this.$swal({
      //       icon: 'error',
      //       title: 'Error!',
      //       text: 'There was an error while processing this transaction. Please try again',
      //       showConfirmButton: false,
      //       timer: 3500
      //     })
      //   })
      //   .finally(() => {
      //     VEvent.fire('loader', false)
      //   })
      // this.modal = false
      this.hash = ''
    }
  }
}
</script>